const DISCLAIMER = '本测试仅供娱乐与自我探索，不构成或替代专业诊疗意见。';

export function ExperienceDisclaimer({ className = '' }: { className?: string }) {
  return <p className={`experience-disclaimer ${className}`.trim()}>{DISCLAIMER}</p>;
}
